var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M7.5 3H5.571a2.61 2.61 0 0 0-1.818.732A2.465 2.465 0 0 0 3 5.5v15c0 .663.27 1.299.753 1.768A2.61 2.61 0 0 0 5.571 23H18.43a2.61 2.61 0 0 0 1.818-.732A2.465 2.465 0 0 0 21 20.5v-15c0-.663-.27-1.299-.753-1.768A2.609 2.609 0 0 0 18.429 3H16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M13.333 1h-2.666C9.194 1 8 1.895 8 3s1.194 2 2.667 2h2.666C14.806 5 16 4.105 16 3s-1.194-2-2.667-2ZM7 19v-7m5 7v-3m5 3v-5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeo);
export default __webpack_public_path__ + "static/media/seo.b1715a31c96c80104eda902b2515031b.svg";
export { ForwardRef as ReactComponent };